module.exports = __webpack_public_path__ + "img/glam.2d96c0d2.png";